import { USER_ROLE } from '@/constants/user'

export function filterNavigationForUserRole (userRole, navigationItems, userAbilities) {
  console.log('USER HAS ROLE OF ', userRole)
  console.log('USER HAS ABILITIES OF ', userAbilities)
  // add visibility element here, if we show or do not show it
  return navigationItems.filter(item => {
    console.log('$$$ RESTRICT ', item.meta?.restrictedTo, ' ', item.title)

    if (item.meta && item.meta.restrictedTo) {
      console.log('$$$ RESTRICT ', item.meta.restrictedTo, ' ', item.title)
      if (item.meta.restrictedTo.includes('Change_Order_Management')) {
        console.log(item.meta.restrictedTo, ' ** change order mgt child ', userAbilities)
        if (userAbilities.CHANGE_ORDER_MANAGER && item.meta.restrictedTo.includes(userRole)) {
          console.log('allowed to see', item.title, userRole)
          return true
        }
      }
      if (item.meta.restrictedTo.includes('Change_Order_Allowed') ) {
        console.log(item.meta.restrictedTo, ' ** change order allowed child ', userAbilities)
        if (userAbilities.CHANGE_ORDER_ALLOWED) {
          console.log('allowed to see', item.title, userRole)
          return true
        }
      }
      if (item.meta.restrictedTo.includes(userRole) ) {
        return true
      }
      return false
    }
    if (item.children) {
      let visibleChildren = item.children.filter(child =>
        !child.meta || !child.meta.restrictedTo || child.meta.restrictedTo.includes(userRole), 
      )
      item.children.forEach(entry => {
        if (entry.meta && entry.meta.restrictedTo) {
          // start here
          if (entry.meta.restrictedTo.includes('Change_Order_Management')) {
            console.log(entry.meta.restrictedTo, ' ** change order mgt child ', userAbilities)
            if (userAbilities.CHANGE_ORDER_MANAGER && entry.meta.restrictedTo.includes(userRole) ) {
              console.log('allowed to see', entry, userRole)
              visibleChildren.push(entry) 
            }
          }
          if (entry.meta.restrictedTo.includes('Change_Order_Allowed') ) {
            console.log(entry.meta.restrictedTo, ' ** change order allowed child ', userAbilities)
            if (userAbilities.CHANGE_ORDER_ALLOWED) {
              console.log('allowed to see', entry, userRole)
              visibleChildren.push(entry) 
            }
          }


        }
      })
      console.log('visible childs ', visibleChildren)
      if (visibleChildren.length) {
        item.children = visibleChildren
        return true
      }
      return false
    }
    return true
  })
}

export function findPermissionsForRoute (navigationItems, route) {
  console.log('find perms for route ', route)
  for (let i = 0; i < navigationItems.length; i++) {
    if (navigationItems[i].children) {
      const result = findPermissionsForRoute(navigationItems[i].children, route)
      if (result === undefined) {
        console.log('nav result undef ', result, ' returning navigationItems[i].meta?.restrictedTo ', navigationItems[i].meta?.restrictedTo)
        return navigationItems[i].meta?.restrictedTo
      } else if (result !== null) {
        console.log('OK FINE going to ', result)
        return result
      }
    } else if (navigationItems[i].to === route) {
      console.log('nav is not child ??? navigationItems[i].meta?.restrictedTo ', navigationItems[i].meta?.restrictedTo, route)
      return navigationItems[i].meta?.restrictedTo
    } 
  }
  return null
}

export function canCreateNewUser (userGroup) {
  switch (userGroup) {
    case USER_ROLE.PLATFORM_ADMIN:
      return true
    default:
      return false
  }
}

export function hasValidRole (user) {
  console.log('check user ', user)
  console.log('has valid role ', Object.values(USER_ROLE).includes(user.status), Object.values(USER_ROLE), user, USER_ROLE)
  if (user.status === 'admin' || user.status === 'Admin') {
    return true
  }
  if (user.status === 'corporate' || user.status === 'viewer'|| user.status === 'vieweronly'|| user.status === 'deposituser'|| user.status === 'storemanager'|| user.status === 'groupmanager'|| user.status === 'CashConnect') {
    return true
  }
  // CC gets their own status
  if (user.status === 'CashConnect') {
    return true
  }
  if (user.group === 'UNSET' && !user.institution ) {
    console.log('user roles says this user has no role and is not inst user ')
    return false
  }
  if (user.status !== 'Active') return false
  return Object.values(USER_ROLE).includes(user.status)
}
